/* eslint-disable import/no-anonymous-default-export */
export default [
  'ADMIN',
  'MEMBER',
  'MARKETING',
  'ANONYMOUS',
]
